export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-swap-140e65b8c3090e94c131d913406aa5e7.png";